<div class="row row-padding-bottom" style="padding-top: 15px;">
  <div class="medium-12">
    <div class="row no-hover client-todos tax-strategy client-plans badge-tables" style="height: 30vh;overflow-y: scroll; padding: 0;">
      <div class="medium-12 large-12 tpiq-paginated-table invoices scenarios">
        <table style="margin-top: 0 !important;font-size: 15px;color: #333333;">
          <thead>
          <tr>
            <th *ngFor="let column of columns">
              <span>{{column.title}}</span>
            </th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <ng-template [ngIf]="todosList && todosList.length == 0">
            <tr class="text-center">
              <td [attr.colspan]="columns.length">
                <div class="callout text-center">
                  <p>No Results Found.</p>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template [ngIf]="todosList && todosList.length > 0">
            <tr class="pointer" *ngFor="let row of todosList;let i=index" (click)="navigateToTodoSinglePage(row)">
              <td *ngFor="let col of columns;let idx=index">
                <div class="pointer table-col">
                  {{row[col.name]}}
                </div>
              </td>
            </tr>
          </ng-template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
